<script>
    import { Modal, ModalBody, ModalFooter } from 'sveltestrap';
    
    import { config } from '../config.js';
    import { showDisclaimer } from '../stores.js';
    
    let disclaimerTimeout = 15;
    let continueEnabled = false;

    var disclaimerTimer = setInterval(() => {
        if (disclaimerTimeout < 2) {        
            continueEnabled = true;
            clearInterval(disclaimerTimer);
        } else {
            disclaimerTimeout--;
        }
    }, 1000);
    
    function closeModal() {
        showDisclaimer.set(false);
        localStorage.setItem("disclaimer-viewed", Date.now());
    }
</script>

<style>
    .text-muted {
        padding: 4px 0 3px 0;
    }
</style>

{#if $showDisclaimer}
    <Modal isOpen={"true"} backdrop="static">
        <ModalBody>
            <p>AIM is a tool to help prison staff analyse data in order to identify vulnerable {$config.inmateLabelName.toLowerCase()}s who may be at risk of suicide or self-harm.</p>
            <p><b>It will not identify all {$config.inmateLabelName.toLowerCase()}s who could be at risk</b> and should only be used as an addition to, not a substitute for local knowledge.</p>
            <p>AIM is provided as an additional tool which provides staff with a more analytical lens from which they can identify patterns of vulnerability and seek to intervene to protect the lives of those in custody.</p>
        </ModalBody>
        <ModalFooter>
            {#if continueEnabled}
                <button type="button" class="btn btn-sm btn-primary" on:click={() => {closeModal()}}>Continue</button>
            {:else}
                <span class="text-muted">Wait {disclaimerTimeout}s...</span>
            {/if}
        </ModalFooter>
    </Modal>
{/if}